// userSelectors.js

export const selectCheckupList = (state) => state.checkups.checkupList;
export const selectLoading = (state) => state.checkups.loading;
export const selectCheckupSelectedData = (state) => state.checkups.selectedData;
export const selectHealthRecords = (state) => state.checkups.healthRecords;
export const selectPackageList = (state) => state.checkups.packageList;
export const selectPackageIdList = (state) => state.checkups.packageId;
export const selectAddPackageSuccessMsg = (state) => state.checkups.successMsg;
export const selectPackagePromotions = (state) => state.checkups.packagaePromotions;


